var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupleAmodi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,4c-0.5,0-1-0.4-1-1V2h-1c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h3v2.9C22,3.6,21.5,4,21,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,18.5c-0.5,0-1-0.4-1-1v-3.6c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1v3.6C22,18.1,21.5,18.5,21,18.5z M21,11.2 c-0.5,0-1-0.4-1-1V6.8c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1v3.6C22,10.8,21.5,11.2,21,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,24.2h-3c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h1v-1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1V24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,24.2h-2.9c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1H16c0.5,0,1,0.4,1,1S16.5,24.2,16,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,24.2H7v-2.9c0-0.5,0.4-1,1-1s1,0.4,1,1v1h1c0.5,0,1,0.4,1,1C11,23.8,10.5,24.2,10,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,18.7c-0.5,0-1-0.4-1-1v-3.6c0-0.5,0.4-1,1-1s1,0.4,1,1v3.6C9,18.2,8.5,18.7,8,18.7z M8,11.4c-0.5,0-1-0.4-1-1V7 c0-0.5,0.4-1,1-1s1,0.4,1,1v3.6C9,11,8.5,11.4,8,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,4C7.5,4,7,3.6,7,3V0.2h3c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1H9v1C9,3.6,8.5,4,8,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9,2.1H13c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h2.9c0.5,0,1,0.4,1,1S16.4,2.1,15.9,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,20.4H16V5h14V20.4z M17,19.5h12V6H17V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,30H0V5h13V30z M1,29h11V6H1V29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupleAmodi);
export default __webpack_public_path__ + "static/media/couple_amodi.e90824f4e1d29ec8ade2e50b26f57690.svg";
export { ForwardRef as ReactComponent };